import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Skeleton,
} from "@mui/material";

import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import GainsOrLoses from "src/components/common/GainsOrLoses";

import { CardStyles } from "./styles/Card.styles";
import { CardProps } from "./types";
import { cardConstants } from "./constants";
import GA from "src/analytics/googleAnalytics";
import { useHistory } from "react-router-dom";
import { useAppDispatch } from "src/store/store";
import { toggleFilterOptions } from "src/store/features/markets.slice";
import Rank from "src/components/markets/Rank";
import { trackEvent } from "src/Amplitude";

const Card = (props: CardProps) => {
  //STYLES
  const classes = CardStyles();

  // REDUX
  const dispatch = useAppDispatch();

  // REACT ROUTER
  const history = useHistory();
  const handleNavigation = (code: string) => {
    GA.coinSelected(window.location.pathname, code);
    history.push(`/coin/${code.toLowerCase()}`);
  };

  // TRIGGER MARKET TABLE TO HIGHLIGHT OPTION AND LOAD TABLE DATA
  const handleSeeMore = (option: string) => {
    trackEvent(`Select_Markets_Page`, {
      option: props.title,
    });
    if (option === "Trending") {
      return;
    }
    dispatch(toggleFilterOptions(option));
  };

  // FORMAT NAME LIKE 'DARWINIA NETWORK NATIVE TOKEN' INTO 'DARWINIA NET...'
  const formatExtraLongNames = (name: string): string => {
    if (name.length > 12) {
      const splitName = name.slice(0, 12);
      return `${splitName}...`;
    }
    return name;
  };

  return (
    <Grid container className={classes.container}>
      {/* TITLE */}
      <Grid item xs={12} container justifyContent="space-between" className={classes.topContainer}>
        <Grid item xs={9}>
          <Typography className={classes.title}>{props.title}</Typography>
        </Grid>
        {/* SEE MORE */}
        {props.title !== "Trending" && (
          <Grid item xs={3}>
            <Typography className={classes.link} onClick={() => handleSeeMore(props.title)}>
              <u>{cardConstants.linkText}</u>
            </Typography>
          </Grid>
        )}
      </Grid>

      {/* DESCRIPTION */}
      <Grid item xs={12} container className={classes.middleContainer}>
        <Grid item xs={12}>
          {props.description}
        </Grid>
      </Grid>

      {/* TOKEN LIST */}

      <Grid item xs={12} container>
        <Grid item>
          <List className={classes.listContainer}>
            {props.listLoading ? (
              // LIST LOADING IS TRUE
              <Skeleton
                sx={{ borderRadius: "4px" }}
                variant="rectangular"
                width="100%"
                height={135}
              />
            ) : props.list && props.list.length <= 0 ? (
              // NO LIST DATA
              <p>{cardConstants.noListData}</p>
            ) : (
              props.list?.map((el) => (
                <ListItem
                  key={el.code}
                  className={classes.listItem}
                  onClick={() => {
                    handleNavigation(el.code);
                    trackEvent("Select_Markets_Page", {
                      option: props.title + formatExtraLongNames(el.name),
                    });
                  }}>
                  {/* RANK */}
                  <ListItemText className={classes.listItemRank}>
                    <Rank rank={el.rank ? el.rank : 1} isActive={el.status} />
                  </ListItemText>
                  {/* ICON */}
                  <ListItemAvatar className={classes.listItemIcon}>
                    <CountryOrCryptoFlag name={el.icon || el.code} size={30} />
                  </ListItemAvatar>
                  {/* NAME AND CODE */}
                  <ListItemText>
                    <Typography className={classes.listName}>
                      <b>{formatExtraLongNames(el.name)}</b> {el.code}
                    </Typography>
                  </ListItemText>
                  {/* CHANGE */}
                  <ListItemText style={{ textAlign: "end", fontSize: "14px" }}>
                    <GainsOrLoses balance={el["24h"]} />
                  </ListItemText>
                </ListItem>
              ))
            )}
          </List>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Card;
